import { Stack, Typography } from '@mui/material';
import { MultiSelectFilter } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { SupplierBase } from '@retail/suppliers/types';

interface Props {
  suppliers: SupplierBase[];
  selectedSupplierNumbers: number[];
  isFetching: boolean;
  selectSuppliers: (supplierNumber: number[]) => void;
}

export function SelectSuppliersAutocomplete({
  suppliers,
  selectedSupplierNumbers,
  isFetching,
  selectSuppliers,
}: Props) {
  const t = useProductsTFunction();

  return (
    <MultiSelectFilter
      label={t('products.supplier.name')}
      placeholder={t('products.supplier.searchForSuppliers')}
      options={suppliers}
      value={suppliers.filter(({ supplierNumber }) =>
        selectedSupplierNumbers.includes(supplierNumber)
      )}
      onChange={(selected) => selectSuppliers(selected.map(({ supplierNumber }) => supplierNumber))}
      disabled={isFetching}
      dividers
      getOptionKey={({ supplierNumber }) => supplierNumber}
      getOptionLabel={({ name, supplierNumber }) => `${name} ${supplierNumber}`}
      getChipLabel={({ name }) => name}
      renderOptionContent={({ name, supplierNumber }) => (
        <Stack>
          <Typography variant="body2">{name}</Typography>
          <Typography variant="caption" component="p">
            {supplierNumber}
          </Typography>
        </Stack>
      )}
    />
  );
}
